import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputText } from 'primereact/inputtext';
import { Chips } from 'primereact/chips';
import { OpenRouterOptionsInterface } from '../../../../app/interfaces/ProviderOptionsInterface';

export interface OpenRouterOptionsProps {
  options: OpenRouterOptionsInterface;
  onChange: (options: OpenRouterOptionsInterface) => void;
}

const OpenRouterOptions: React.FunctionComponent<OpenRouterOptionsProps> = (props: OpenRouterOptionsProps) => {
  const { options, onChange } = props;
  const { t } = useTranslation();

  const handlePreferredProviderChange = (value: string) => {
    onChange({
      ...options,
      routingSettings: {
        ...(options.routingSettings || {}),
        preferredProvider: value
      }
    });
  };

  const handleFallbackProvidersChange = (value: string[]) => {
    onChange({
      ...options,
      routingSettings: {
        ...(options.routingSettings || {}),
        fallbackProviders: value
      }
    });
  };

  return (
    <div className="openrouter-options">
      <h4 className="text-lg mb-2">{t('provider_options.openrouter.title')}</h4>
      
      <div className="p-field mb-3">
        <label htmlFor="openrouter-preferred-provider" className="block mb-1">
          {t('provider_options.openrouter.preferred_provider')}
        </label>
        <InputText
          id="openrouter-preferred-provider"
          value={options.routingSettings?.preferredProvider || ''}
          onChange={(e) => handlePreferredProviderChange(e.target.value)}
          placeholder={t('provider_options.openrouter.preferred_provider_placeholder')}
          className="w-full"
        />
        <small className="text-xs text-gray-500 block mt-1">
          {t('provider_options.openrouter.preferred_provider_help')}
        </small>
      </div>

      <div className="p-field mb-3">
        <label htmlFor="openrouter-fallback-providers" className="block mb-1">
          {t('provider_options.openrouter.fallback_providers')}
        </label>
        <Chips
          id="openrouter-fallback-providers"
          value={options.routingSettings?.fallbackProviders || []}
          onChange={(e) => handleFallbackProvidersChange(e.value)}
          placeholder={t('provider_options.openrouter.fallback_providers_placeholder')}
          className="w-full"
        />
        <small className="text-xs text-gray-500 block mt-1">
          {t('provider_options.openrouter.fallback_providers_help')}
        </small>
      </div>
    </div>
  );
};

export default OpenRouterOptions;